// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1nXw3","right":"styles_right__2I1YR"};